import { render } from "./ToastComponent.vue?vue&type=template&id=3c0fd4d7"
import script from "./ToastComponent.vue?vue&type=script&lang=js"
export * from "./ToastComponent.vue?vue&type=script&lang=js"

import "./ToastComponent.vue?vue&type=style&index=0&id=3c0fd4d7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__